export default __webpack_public_path__ + "static/media/darkLogo.06ed9232.svg";